export const placeholder = 'Search for templates';

export const defaultBackgroundImage = {
  src: 'https://pastatic.picsart.com/cms-pastatic/4b0d777e-af8c-4984-8310-70093f0f9e36.png?to=min&r=1600&type=webp&q=100',
  alt: 'Banner image',
};
